import { mutations } from './mutations';

export default {
    namespaced: true,
    
    state: () => ({
        selectedFmk: null,
        selections: {
            width: null,
            ratio: null,
            diameter: null
        },
        options: {
            width: [],
            ratio: [],
            diameter: []
        },
        selected: {
            width: '',
            ratio: '',
            diameter: ''
        }
    }),
    getters: {
        getWidth: state => state.selected.width,
        getRatio: state =>state.selected.ratio,
        getDiameter: state =>state.selected.diameter,
    },
    
    mutations
};